import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setBasicFilters } from '@/redux/store/actions/search';
import { BasicFiltersStateProps } from '@/redux/store/types';
import useSearchParams from '../hooks/useSearchParams';
import Button from '../../UI/button/Button';
import Box from '../../UI/box/Box';
import Drawer from '@/components/UI/drawer/Drawer';
import Icon from '../../UI/icon/Icon';
import DatePicker from '@/components/reusable/searchDatePicker/DatePicker';
import styles from './SelectCheckinPopUp.module.scss';
import Typography from '@/components/UI/typography/Typography';
const SelectCheckinPopUp = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);
  const {
    setQuery
  } = useSearchParams();
  const [open, setOpen] = useState(false);
  const [openPopUp, setOpenPopUp] = useState(false);
  const {
    checkin,
    checkout,
    guests
  }: BasicFiltersStateProps = useSelector(state => state.basicFilters);
  useEffect(() => {
    const checkin = parseInt(router.query?.checkin as string) || null;
    const checkout = parseInt(router.query?.checkout as string) || null;
    const hasSeenDialog = sessionStorage.getItem('diolog-seen') === 'true';
    setTimeout(() => {
      if (!sessionStorage.getItem('previous_page') && !hasSeenDialog && (!checkin && !checkout || checkin && checkin < today.getTime())) {
        setOpenPopUp(true);
        sessionStorage.setItem('diolog-seen', 'true');
      }
    }, 10);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const resetFilter = (e: React.MouseEvent<HTMLButtonElement>) => {
    dispatch(setBasicFilters({
      checkin: null,
      checkout: null,
      guests
    }));
    if (checkout) {
      setQuery({
        checkin: null,
        checkout: null
      });
    }
  };
  const handleDatePickerChange = (dates: any) => {
    dispatch(setBasicFilters({
      checkin: dates.checkin,
      checkout: dates.checkout,
      guests
    }));
    if (dates.submited) {
      setOpen(false);
      setOpenPopUp(false);
      setQuery({
        checkin,
        checkout
      });
    }
  };
  return <>
      <Drawer open={openPopUp} onClose={() => setOpenPopUp(false)} data-sentry-element="Drawer" data-sentry-source-file="SelectCheckinPopUp.tsx">
        <Box className={styles['checkin-popup-container']} data-sentry-element="Box" data-sentry-source-file="SelectCheckinPopUp.tsx">
          <Box className={styles['header-wrapper']} data-sentry-element="Box" data-sentry-source-file="SelectCheckinPopUp.tsx">
            <Box className={styles['icon-wrapper']} data-sentry-element="Box" data-sentry-source-file="SelectCheckinPopUp.tsx">
              <Icon type={'inherit'} name={'calendar-tick-Filled'} size="large" data-sentry-element="Icon" data-sentry-source-file="SelectCheckinPopUp.tsx" />
            </Box>
            <Typography variant="title_Bold" data-sentry-element="Typography" data-sentry-source-file="SelectCheckinPopUp.tsx">انتخاب تاریخ رزرو</Typography>
          </Box>
          <Box className={styles['content-wrapper']} data-sentry-element="Box" data-sentry-source-file="SelectCheckinPopUp.tsx">
            <Typography className={styles['checkin-text']} component="p" variant="bodyL" data-sentry-element="Typography" data-sentry-source-file="SelectCheckinPopUp.tsx">
              برای مشاهده قیمت‌های‌ دقیق‌ و اقامتگاه‌های مناسب‌تر تاریخ رزرو خود
              را انتخاب کنید.
            </Typography>
            <Box className={styles['button-wrapper']} data-sentry-element="Box" data-sentry-source-file="SelectCheckinPopUp.tsx">
              <Box className={styles['close-button']} data-sentry-element="Box" data-sentry-source-file="SelectCheckinPopUp.tsx">
                <Button onClick={() => {
                setOpenPopUp(false);
              }} format="outlined" data-sentry-element="Button" data-sentry-source-file="SelectCheckinPopUp.tsx">
                  بستن
                </Button>
              </Box>
              <Button onClick={() => {
              setOpen(true);
            }} format="primary" data-sentry-element="Button" data-sentry-source-file="SelectCheckinPopUp.tsx">
                انتخاب تاریخ
              </Button>
            </Box>
          </Box>
        </Box>
      </Drawer>
      <DatePicker open={open} setOpen={() => setOpen(false)} handleReset={resetFilter as (e: React.MouseEvent<HTMLButtonElement> | boolean) => void} handleDatePickerChange={handleDatePickerChange} data-sentry-element="DatePicker" data-sentry-source-file="SelectCheckinPopUp.tsx" />
    </>;
};
export default SelectCheckinPopUp;